import { z } from 'zod';

/** Per spec §12.5 — the WebSocket payload union the TUI consumes. */

export const wsState = z.object({
  type: z.literal('state'),
  data: z.record(z.string(), z.unknown()),
});

export const wsDelta = z.object({
  type: z.literal('delta'),
  data: z.record(z.string(), z.unknown()),
});

export const wsChat = z.object({
  type: z.literal('chat'),
  data: z.object({
    role: z.enum(['assistant', 'user', 'system']),
    chunk: z.string(),
    done: z.boolean().optional(),
  }),
});

export const wsLog = z.object({
  type: z.literal('log'),
  data: z.object({
    branch: z.string().optional(),
    line: z.string(),
    ts: z.string(),
  }),
});

export const wsEvent = z.object({
  type: z.literal('event'),
  data: z.object({
    decision_id: z.string().uuid(),
    summary: z.string(),
    refs: z.record(z.string(), z.string()).optional(),
  }),
});

export const wsMessage = z.discriminatedUnion('type', [
  wsState,
  wsDelta,
  wsChat,
  wsLog,
  wsEvent,
]);
export type WsMessage = z.infer<typeof wsMessage>;
